module.exports = __webpack_public_path__ + "img/RUDITE.7a2ea1e6.png";